export default "__VITE_ASSET__RLsd9v$b__"